module.exports = __webpack_public_path__ + "static/img/bg-08.70ebdd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt/bg-08.jpg
// module id = fj+5
// module chunks = 1